<div class="modal-overlay" (click)="close()">
  <div class="admin-modal" style="width: 750px;" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">{{ mode === 'edit' ? 'Edit' : 'New' }} Channel</h3>
      <div class="header-actions">
        <i class="fa" [ngClass]="{'fa-plus-square-o': channelModalMinimise, 'fa-minus-square-o': !channelModalMinimise}"
           style="margin-right: 10px; cursor: pointer;" [title]="channelModalMinimise ? 'Maximize' : 'Minimize'" (click)="channelModalMinimise = !channelModalMinimise"></i>
        <i class="fa fa-times" style="cursor: pointer;" title="Close" (click)="close()"></i>
      </div>
    </div>
    <div class="modal-body" [hidden]="channelModalMinimise">
      <div class="row" style="margin: 10px 5px;">
        <div class="col-md-3">
          <label>Channel Name: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Unique channel name" direction="top"></i></label>
          <input type="text" class="form-control" maxlength="50" placeholder="enter Channel name"
            [(ngModel)]="channelForm.channel_name" [ngModelOptions]="{standalone: true}" [disabled]="mode === 'edit'">
        </div>
        <div class="col-md-3">
          <label>Channel Desc: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Channel description" direction="top"></i></label>
          <textarea class="form-control" placeholder="enter channel desc" maxlength="2000"
            [(ngModel)]="channelForm.channel_desc" [ngModelOptions]="{standalone: true}"></textarea>
        </div>
        <div class="col-md-3">
          <label>Channel Priority: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Priority number" direction="top"></i></label>
          <input type="number" class="form-control" placeholder="enter priority"
            [(ngModel)]="channelForm.channel_priority" [ngModelOptions]="{standalone: true}">
        </div>
        <div class="col-md-3">
          <label>Channel Status: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Active or Inactive" direction="top"></i></label>
          <select class="form-control" [(ngModel)]="channelForm.channel_status" [ngModelOptions]="{standalone: true}">
            @for (s of channelStatusList; track $index) {
<option [ngValue]="s.value">{{ s.name }}</option>
}
          </select>
        </div>
      </div>
    </div>
    <div class="modal-footer" [hidden]="channelModalMinimise">
      <button class="btn btn-primary btn-sm" type="button" (click)="saveChannelModal()" [disabled]="channelSaveLoading">
        Save @if (channelSaveLoading) {
<i class="fa fa-spinner fa-spin"></i>
}
      </button>
      <button class="btn btn-info btn-sm" type="button" (click)="close()">Cancel</button>
      <button class="btn btn-info btn-sm" type="button" (click)="clearChannelForm()">Clear Form</button>
      @if (mode === 'edit') {
<button class="btn btn-danger btn-sm" type="button"
        (click)="confirmRemoveChannel(channelForm.channel_key)">Remove</button>
}
    </div>
  </div>
</div>

<!-- Confirmation Modal (internal) -->
@if (showConfirmModal) {
<div class="modal-overlay" style="z-index: 1060;" (click)="cancelConfirm()">
  <div (click)="$event.stopPropagation()">
    <gtw-confirmation-modal
      [config]="confirmModalConfig"
      [visible]="false"
      (confirmed)="executeConfirm()"
      (cancelled)="cancelConfirm()"
      (closed)="cancelConfirm()">
    </gtw-confirmation-modal>
  </div>
</div>
}
